import { useEffect, useRef } from 'react'

/**
 * Hook que activa las clases de animación scroll reveal cuando el elemento entra en viewport.
 * Añade 'revealed' a los elementos con clase 'reveal', 'reveal-left' o 'reveal-right'
 * dentro del contenedor referenciado.
 */
export function useScrollReveal<T extends HTMLElement = HTMLElement>(
  threshold = 0.12,
) {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const targets = el.querySelectorAll<HTMLElement>(
      '.reveal, .reveal-left, .reveal-right',
    )
    if (targets.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold },
    )

    targets.forEach((t) => observer.observe(t))

    return () => observer.disconnect()
  }, [threshold])

  return ref
}
